<div class="container-md">
    <h3>{{'scan.aside.title' | translate}}</h3>
    <hr>
    <article>
        <router-outlet></router-outlet>
    </article>
</div>
